
<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="24">
                        <span class="title">订单编号:</span>

                        <el-input
                            v-model="search_data.billno"
                            placeholder="请输入订单编号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchOverspeed"
                        ></el-input>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchOverspeed">搜索</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-form style="margin-top: 20px;display:flex">
              
                <el-form-item label="超速提醒 :" label-width="100px">
                    <el-switch v-model="submit_data.overspeed_open" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="市内限速 :" label-width="100px">
                    <el-input v-model="submit_data.overspeed_city" style="width: 60px; margin-right: 20px"> </el-input>
                </el-form-item>
                <el-form-item label="高速限速 :" label-width="100px">
                    <el-input v-model="submit_data.overspeed_highway" style="width: 60px"> </el-input>
                </el-form-item>
                <el-form-item  label-width="20px">
                    <el-button type="primary" @click="saveOverspeed">保存</el-button>
                </el-form-item>               
                
            </el-form>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="billno" label="订单编号"> </el-table-column>
            <el-table-column prop="driver_name" label="司机姓名"> </el-table-column>
            <el-table-column prop="start_coordinate" label="起点坐标"> </el-table-column>
            <el-table-column prop="start_time" label="开始时间"> </el-table-column>
            <el-table-column prop="end_coordinate" label="终点坐标"> </el-table-column>
            <el-table-column prop="end_time" label="结束时间"> </el-table-column>
            <el-table-column prop="top_speed" label="最高速度"> </el-table-column>
        </el-table>

        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
var _this;

export default {
    data() {
        return {
            overspeed_open: 0,
            overspeed_city: '',
            overspeed_highway: '',
            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                billno: ''
            },
            submit_data: {
                overspeed_open: '',
                overspeed_city: '',
                overspeed_highway: ''
            },

            result_data: {},
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            submit_rules: {
                overspeed_city: {
                    placeholder: '市内超速',
                    rules: {
                        required: true,
                        message: '市内超速需要大于等于0',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                overspeed_highway: {
                    placeholder: '高速超速',
                    rules: {
                        required: true,
                        message: '高速超速需要大于等于0',
                        regulation: 'egt',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchOverspeed();
        _this.getConfig();
    },

    methods: {
        saveOverspeed() {
            _this
                .$post('/overspeed/setConfig', _this.submit_data, _this.submit_rules)
                .then((res) => {
                  this.$message.success(res.msg)
                    _this.getConfig();
                })
                .catch((err) => {});
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.orderListsAll();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.orderListsAll();
        },

        searchOverspeed() {
            _this.search_data.page = 1;
            _this.orderListsAll();
        },

        orderListsAll() {
            _this
                .$post('/overspeed/list', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                    _this.overspeed_open = res.data.overspeed_open;
                })
                .catch((err) => {});
        },
        getConfig() {
            _this
                .$post('/overspeed/getConfig')
                .then((res) => {
                    _this.submit_data.overspeed_open = res.data.overspeed_open;
                    _this.submit_data.overspeed_city = res.data.overspeed_city;
                    _this.submit_data.overspeed_highway = res.data.overspeed_highway;
                })
                .catch((err) => {});
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, "val");
            _this.search_data.limit = val;

            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            // console.log(val, "val页码变化");
            _this.search_data.page = val;

            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            // console.log("翻页组件回调");
            //初始化列表
            _this.orderListsAll();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>

